<template>
  <div class="global-page-container" :class="[ pageContainerClass ]">
    <div class="header">
      <main-toolbar class="main-toolbar" v-if="auth && !hideToolbar"></main-toolbar>

      <div class="logo-wrapper" :class="[logoSize]">
        <div v-if="disableEasyNavigation" class="logo">
          <logo></logo>
        </div>
        <router-link v-else :to="{ name: 'home' }" class="logo" @click.native="trackEasyNavigation">
          <logo></logo>
        </router-link>
      </div>
    </div>
    <router-view class="main"></router-view>
  </div>
</template>

<script>

import MainToolbar from '@/containers/MainToolbar';
import Logo from '@/components/Logo';

export default {
  name: 'GlobalPageContainer',
  components: {
    MainToolbar,
    Logo,
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    logoSize() {
      return (this.$route.meta && this.$route.meta.logoSize) || 'normal';
    },
    pageContainerClass() {
      return this.$route.meta && this.$route.meta.pageContainerClass;
    },
    hideToolbar() {
      return this.$route.meta && this.$route.meta.hideToolbar;
    },
    disableEasyNavigation() {
      return this.$store.getters.disableEasyNavigation;
    },
  },
  methods: {
    trackEasyNavigation() {
      this.$ga.event('easy-navigation', 'clicked', 'logo');
    },
  },
};

</script>

<style scoped>

.global-page-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1;
}

.main-toolbar {
  float: right;
  margin: 5px 10px 0 0;
}

.logo-wrapper {
  /*width: 100px;*/
  /*height: 60px;*/
  margin: 0 auto 5px auto;
  display: block;
  transition: width .5s, margin-top .5s;
}

.logo-wrapper.normal {
  width: 100px;
  margin-top: 10px;
}

.logo-wrapper.big {
  width: 140px;
  margin-top: 40px;
}

.logo-wrapper.giant {
  width: 300px;
  margin-top: 50px;
}

.logo-wrapper.giant .logo {
  stroke: #eee !important;
}

</style>



// WEBPACK FOOTER //
// src/containers/GlobalPageContainer.vue